import React from "react";
import styles from "./loader.css";

interface Props {
  widgetStyle?: boolean;
}

export class LoaderComponent extends React.Component<Props, {}> {
  render() {
    return (
      <div className={[styles.loader, this.props.widgetStyle ? "" : styles.dashboard].join(" ")}>
        <div className={styles.segment0} />
        <div className={styles.segment1} />
        <div className={styles.segment2} />
        <div className={styles.segment3} />
        <div className={styles.segment4} />
        <div className={styles.segment5} />
        <div className={styles.center} />
        <div className={styles.head} />
      </div>
    );
  }
}
